module.exports = __webpack_public_path__ + "img/9788949123196.010deb1a.jpg";